<template>
  <div class="question-tab-content-text position-relative">
    <div class="d-flex align-items-center flex-wrap gap-10 pb-2 border-bottom">
    <div class="question-tab-content-img">
              <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M17.294 7.29105C17.294 10.2281 14.9391 12.5831 12 12.5831C9.0619 12.5831 6.70601 10.2281 6.70601 7.29105C6.70601 4.35402 9.0619 2 12 2C14.9391 2 17.294 4.35402 17.294 7.29105ZM12 22C7.66237 22 4 21.295 4 18.575C4 15.8539 7.68538 15.1739 12 15.1739C16.3386 15.1739 20 15.8789 20 18.599C20 21.32 16.3146 22 12 22Z" fill="#fff" fill-rule="evenodd"/>
              </svg>
            </div>
      <p class="fontsize-medium font-w-900 text-color-grey m-0">
        {{ comment.name }}
      </p>
      <p class="date fontsize-mini text-secondary m-0" style="word-spacing: 4px">
        {{ moment(comment.created_at).format('HH:mm YYYY/MM/DD') }}
      </p>
    </div>

    <p class="user-question-text fontsize-mini text-color-grey pt-2 px-2 text-justify">
      {{ comment.body }}
    </p>
    <template v-if="answerable" >
      <a class=" fontsize-mini font-w-900 text-color-grey px-3 py-2 border-r-10" style="background-color:var(--color-border)" @click.prevent="$emit('answer', comment.id)">
        پاسخ دهید
      </a>
      <div class="mt-2 window" :class="{open: answeringComment === comment.id}">
        <transition name="window-fade">
          <CommentForm @commentAdded="onCommentAdded" :blog-id="blogId" v-if="answeringComment === comment.id" :parent-id="comment.id"  />
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
import CommentForm from "@/parts/Front/components/weblog/CommentForm";
import ZSvgCommentAnswer from "@/parts/Front/components/weblog/ZSvgCommentAnswer";
export default {
  name: "Comment",
  components: {ZSvgCommentAnswer, CommentForm},
  props: {
    answerable: Boolean,
    comment: Object,
    answeringComment: {
      default: null,
      type: [Number, String]
    },
    blogId: [Number,String]
  },
  methods: {
    onCommentAdded(comment) {
      this.comment.children.unshift(comment)
      this.$emit('commentAdded', null)
    }
  }
}
</script>

<style scoped>
.window {
  display: block;
  min-height: 0;
  width: 100%;
  transition: 200ms all;
  position: relative;
}

.window.open {
  min-height: 365px;
}

.window > * {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.window-fade-leave-active,
.window-fade-enter-active {
  transition: 300ms;
}
.window-fade-enter {
  opacity: 0;
  transform: translate(0, 2%);
}
.window-fade-leave-to {
  opacity: 0;
  transform: translate(0, -2%);
}
@media screen and (max-width: 600px){
  .window.open {
    min-height: 370px;
  }
  .date {
    position: absolute;
    left: 0;
    top: 0;
  }
}

</style>
